var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      class: ["drawer", _vm.direction === "btt" && "bbt-rrawer"],
      attrs: {
        visible: _vm.drawer,
        title: _vm.title,
        "append-to-body": true,
        "with-header": _vm.withHeader,
        size: _vm.size,
        modal: true,
        "close-on-click-modal": "",
        "destroy-on-close": _vm.destroyOnClose,
        "before-close": _vm.handleClose,
        direction: _vm.direction,
        "close-on-press-escape": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _vm.customTitle
        ? _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [_vm._t("title")],
            2
          )
        : _vm._t("title"),
      _c("div", { staticClass: "drawer-content" }, [_vm._t("default")], 2),
      _vm.isShowFooter
        ? _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [_vm._t("footer")],
            2
          )
        : _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }